(function () {

  /* =========================================================
     HELPERS
  ========================================================= */

  function normalizeLanguage(lang) {
    return (lang || "english").toLowerCase();
  }

  function updateFontOptionsForLanguage(language) {
    var fontSelect = document.getElementById("font-style");
    if (!fontSelect) return;

    var lang = normalizeLanguage(language);
    var options = fontSelect.querySelectorAll("option");
    var firstVisible = null;

    options.forEach(function (option) {
      var optionLang = option.getAttribute("data-language");

      // Universal option (no data-language)
      if (!optionLang) {
        option.hidden = false;
        return;
      }

      if (optionLang.toLowerCase() === lang) {
        option.hidden = false;
        if (!firstVisible) firstVisible = option;
      } else {
        option.hidden = true;
      }
    });

    // Reset font if current selection is hidden
    if (
      fontSelect.selectedOptions.length &&
      fontSelect.selectedOptions[0].hidden &&
      firstVisible
    ) {
      fontSelect.value = firstVisible.value;
      if (window.CustomNecklace) {
        CustomNecklace.set({ font: firstVisible.value });
      }
    }
  }

  /* =========================================================
     RENDER PREVIEW
  ========================================================= */

  function render(state) {
    var preview = document.getElementById("live-name-preview");
    if (!preview) return;

    var text = state.name || "";
    var language = normalizeLanguage(state.language);
    var font = state.font || "";

    preview.textContent = text || "Your Name";
    preview.className = "name-preview";
    preview.style.direction = "ltr";

    /* =======================
       ARABIC
    ======================= */
    if (language === "arabic") {
      preview.classList.add("font-arabic");
      preview.style.direction = "rtl";
      preview.setAttribute("lang", "ar");
      return;
    }

    /* =======================
       HINDI
    ======================= */
    if (language === "hindi") {
      preview.setAttribute("lang", "hi");

      if (font.includes("Calligraphy")) {
        preview.classList.add("preview-hindi-calligraphy");
      } else if (font.includes("Elegant")) {
        preview.classList.add("preview-hindi-elegant");
      } else if (font.includes("Bold")) {
        preview.classList.add("preview-hindi-bold");
      } else if (font.includes("Modern")) {
        preview.classList.add("preview-hindi-modern");
      } else {
        preview.classList.add("preview-hindi-classic");
      }
      return;
    }

    /* =======================
       ENGLISH (DEFAULT)
    ======================= */
    preview.setAttribute("lang", "en");

    if (font.includes("Formal Script")) {
      preview.classList.add("preview-english-formal");
    } else if (font.includes("Rounded Script")) {
      preview.classList.add("preview-english-rounded");
    } else if (font.includes("Light Script")) {
      preview.classList.add("preview-english-light");
    } else if (font.includes("Handwritten Script")) {
      preview.classList.add("preview-english-handwritten");
    } else if (font.includes("Classic")) {
      preview.classList.add("font-classic");
    } else if (font.includes("Bold")) {
      preview.classList.add("font-bold");
    } else if (font.includes("Minimal")) {
      preview.classList.add("font-minimal");
    } else if (font.includes("Old English")) {
      preview.classList.add("font-oldenglish");
    }
  }

  /* =========================================================
     LANGUAGE RADIO HANDLER
  ========================================================= */

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "language-radio") {
      var newLanguage = normalizeLanguage(e.target.value);
      var hiddenLang = document.getElementById("language-value");
      if (!hiddenLang) return;

      hiddenLang.value = newLanguage;

      updateFontOptionsForLanguage(newLanguage);

      if (window.CustomNecklace) {
        CustomNecklace.set({ language: newLanguage });
      }
    }
  });

  /* =========================================================
     INIT
  ========================================================= */

  document.addEventListener("DOMContentLoaded", function () {
    if (!window.CustomNecklace) return;

    CustomNecklace.onChange(render);

    var hiddenLang = document.getElementById("language-value");
    if (hiddenLang) {
      updateFontOptionsForLanguage(hiddenLang.value);
    }

    render(CustomNecklace.get());
  });

})();
